import type { ComponentPropsWithoutRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link as RadixLink } from '@radix-ui/themes';

export function AppLink(props: ComponentPropsWithoutRef<typeof RouterLink>) {
  return (
    <RadixLink asChild>
      <RouterLink {...props} />
    </RadixLink>
  );
}
